import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// ENVs
import { environment } from '../../environments/environment';

// RxJs
import { forkJoin, of } from 'rxjs';
import {retry, catchError, timeout, map} from 'rxjs/operators';

// Libraries
import { DeviceDetectorService } from 'ngx-device-detector';

// services
import { BrowserInfoService } from './browser-info.service';


declare let ClientIP: any;



@Component({
  selector: 'pgs-browser-info',
  templateUrl: './browser-info.component.html',
  styleUrls: ['./browser-info.component.scss']
})
export class BrowserInfoComponent implements OnInit {
  // ipAddress :any
  privateIP = ClientIP;
  publicIP;
  newDate;
  msg = 'Cargando información de microservicios';
  // smOrderHealth;
  // smSmanagerHealth;
  // smUprivateHealth;
  // smProductHealth;
  // smCustomerHealth;
  // smUpublicHealth;
  // smTdocHealth;
  // smVendorHealth;
  errorGif;
  msNames = ['Order', 'S. Manager', 'Product', 'Customer', 'Utils Public', 'Tributary Doc', 'Vendor'];
  msHealth = true;
  loadingHealth = false;
  loadingVersion = false;
  msArrHealth;
  msArrVersion;


  public deviceInfo = null;
  public isMobilevar = false;
  public isTabletvar = false;
  public isDesktopvar = false;




  constructor(private deviceService: DeviceDetectorService,
    private userService: BrowserInfoService,
    private http: HttpClient
    // private BrowserInfoService: BrowserInfoService,

  ) {
    this.http.get('https://api.ipify.org?format=json', { params: { noHeader: 'true', baseurl: 'false' } }).subscribe(data => {
      this.publicIP = data['ip'];

    });
    this.detectDevice();
    this.isMobile();
    this.isTablet();
    this.isDesktop();
  }

  public detectDevice() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    (this.deviceInfo);

  }
  public isMobile() {
    this.isMobilevar = this.deviceService.isMobile();
  }

  public isTablet() {
    this.isTabletvar = this.deviceService.isTablet();
  }

  public isDesktop() {
    this.isDesktopvar = this.deviceService.isDesktop();

  }

  ngOnInit() {

    this.newDate = new Date();

    forkJoin([
      this.msRequests(environment.order_health),
      this.msRequests(environment.service_manager_health),
      this.msRequests(environment.product_health),
      this.msRequests(environment.customer_health),
      this.msRequests(environment.utils_public_health),
      this.msRequests(environment.tributarydoc_health),
      this.msRequests(environment.vendor_health)
    ]).subscribe(results => {
      const status: any = results;
      for (let i = 0; i < results.length; i++) {
        if (status[i].status === 'DOWN') {
          this.msHealth = false;
        }
      }
      this.loadingHealth = true;
      this.msArrHealth = results;

    });

    forkJoin([
      this.msRequests(environment.order_version),
      this.msRequests(environment.service_manager_version),
      this.msRequests(environment.product_version),
      this.msRequests(environment.customer_version),
      this.msRequests(environment.utils_public_version),
      this.msRequests(environment.tributarydoc_version),
      this.msRequests(environment.vendor_version)
    ]).subscribe(results => {
      this.loadingVersion = true;
      this.msArrVersion = results;
    });
  }

  msRequests(msPath): any {
    const mserror = {
      status: 'DOWN'
    };
    return this.http.get(msPath).pipe(
      map(res => res),
      timeout(5000),
      retry(2),
      catchError(err => of(mserror))
    );
  }
}
